module.exports = __webpack_public_path__ + "static/media/heart-beats.6b1fff9c.svg";